/**
 * Zone.js, used by Angular, overrides Object.defineProperty and causes weird issues when some of our external
 * libraries go through babel transpilation during webpack bundling. The following global property is set
 * to disable that behavior in Zone.js. Github issue: https://github.com/angular/angular/issues/37432
 */
(window as any).__Zone_disable_defineProperty = true;
